import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, BugOff } from "lucide-react";
export default function ArcadiaPestControlHero() {
  return <section id="arcadia-pest-control-hero" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <BugOff className="absolute -top-20 -left-20 w-96 h-96 text-foreground rotate-12" />
        <BugOff className="absolute -bottom-20 -right-20 w-96 h-96 text-foreground -rotate-12" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="flex flex-col justify-center text-center lg:text-left">
            <div className="inline-flex items-center justify-center lg:justify-start gap-2 mb-6">
              <ShieldCheck className="w-6 h-6 text-foreground" />
              <span className="font-default text-lg font-semibold tracking-wider uppercase">
                Trusted Local Experts
              </span>
            </div>
            
            <h1 className="font-default text-5xl md:text-7xl lg:text-[86px] leading-[1.1] font-bold mb-8 uppercase tracking-tight">
              Defending Arcadia's Rural Lands <span className="block text-foreground/80 text-4xl md:text-5xl lg:text-6xl mt-2">| Expert Care for Farmland & Historic Homes</span>
            </h1>
            
            <div className="font-default text-xl md:text-2xl mb-10 max-w-2xl mx-auto lg:mx-0 text-foreground/90 leading-relaxed space-y-6">
              <p>
                In the heart of Florida’s cattle country, Arcadia demands a specialized approach to <Link to="/PestControlPage" className="underline decoration-primary">pest control for agricultural areas</Link> and <Link to="/TermiteTreatmentPage" className="underline decoration-primary">termite treatment</Link> that respects its deep-rooted ranching heritage and unique ecological landscape. From the sprawling cattle ranches that define our horizon to the dense hardwood hammocks and the sandy stretches of The Scrub, Arcadia faces pest pressures that urban centers simply do not encounter. Our local environment is a breeding ground for livestock pests and agricultural termites that can compromise both your home’s structure and your livelihood. In Arcadia, the seasonal breeding patterns of grassland mosquitoes and the persistent threat of cattle-tick vectors require a vigilant, year-round strategy.
              </p>
              <p>
                As the agricultural hub of the region, Arcadia residents often struggle with pests that migrate from fields to foundations. The complex network of agricultural drainage across Arcadia provides essential water management for our citrus groves and pastures, but it also serves as a highway for invasive species and moisture-loving insects. We specialize in identifying the specific vulnerabilities of Arcadia homes, particularly those nestled near hardwood hammocks where damp wood termites thrive. Our team is intimately familiar with the unique challenges of Arcadia, from the specific rodent species that plague rural barns to the aggressive mosquito populations that emerge after heavy summer rains. Local, area-specific knowledge is essential to defending your way of life against the persistent pressures of the Florida wilderness.
              </p>
              <p>
                Our specialized agricultural defense extends to neighboring communities, providing expert protection for the rural outskirts of <Link to="#" className="underline decoration-primary">Port Charlotte</Link> and the farming landscapes of <Link to="#" className="underline decoration-primary">North Fort Myers</Link>.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <Button size="lg" asChild className="text-lg px-8 py-7 w-full sm:w-auto">
                <Link to="/ContactPage">
                  Get a Free Quote
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="text-lg px-8 py-7 w-full sm:w-auto border-foreground text-foreground hover:bg-foreground hover:text-background">
                <Link to="/PestControlPage">
                  Our Services
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/5] lg:aspect-square w-full">
              <div className="absolute inset-0 bg-foreground translate-x-4 translate-y-4 lg:translate-x-8 lg:translate-y-8"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/arcadia_pest_control_service_landscape.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/arcadia_pest_control_service_landscape.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/arcadia_pest_control_service_landscape.png-wvc-sizes" alt="Professional pest control service area in Arcadia, FL" className="absolute inset-0 w-full h-full object-cover border-4 border-foreground" loading="eager" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 lg:-left-12 bg-card text-card-foreground p-6 border-4 border-foreground shadow-xl max-w-[240px]">
              <div className="flex items-center gap-4 mb-2">
                <div className="bg-primary text-primary-foreground p-2 rounded-lg">
                  <ShieldCheck className="w-8 h-8" />
                </div>
                <div className="font-default text-3xl font-bold">100%</div>
              </div>
              <p className="font-default text-sm font-semibold uppercase tracking-wider">Satisfaction Guarantee</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}